import { render, staticRenderFns } from "./AccountBanksEditAdmin.vue?vue&type=template&id=cfe41c0c&scoped=true"
import script from "./AccountBanksEditAdmin.vue?vue&type=script&lang=js"
export * from "./AccountBanksEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe41c0c",
  null
  
)

export default component.exports